/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/import-4";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Import4";
export { I as Import4 };
